import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/terms.scss";
import { Link } from "react-router-dom";

function Terms() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="terms">
      <Header />
      <div className="wrapper">
        <div
          id="UUID_378002b2_62f6_45a1_b536_876df7c3c925"
          className="text-left pt-4 pb-4 pl-4 pr-4 d-block d-md-block d-lg-block d-xl-block"
        >
          <div
            id="v0_378002b2_62f6_45a1_b536_876df7c3c925"
            className="verticalspacer parbase"
          >
            <div className="pt-5" />
          </div>
          <div
            id="te1_378002b2_62f6_45a1_b536_876df7c3c925"
            className="font-size-32 font-size-lg-40 text-left font-weight-normal line-height-default font-family-headline text-black"
            role="group"
          >
            website terms and conditions
          </div>
          <div
            id="v2_378002b2_62f6_45a1_b536_876df7c3c925"
            className="verticalspacer parbase"
          >
            <div className="pt-3" />
          </div>
          <div
            id="te3_378002b2_62f6_45a1_b536_876df7c3c925"
            className="font-size-10 font-size-lg-12 text-left line-height-default font-sans-serif text-dark-gray"
            role="group"
          >
            <i>Date of Last Revision: 03/16/2026</i>
          </div>
          <div
            id="v4_378002b2_62f6_45a1_b536_876df7c3c925"
            className="verticalspacer parbase"
          >
            <div className="pt-5 pt-lg-6" />
          </div>
          <div
            id="te5_378002b2_62f6_45a1_b536_876df7c3c925"
            className="font-size-12 font-size-lg-16 text-left line-height-default font-sans-serif text-black"
            role="group"
          >
            PLEASE READ THESE TERMS AND CONDITIONS OF USE CAREFULLY. THESE TERMS
            AND CONDITIONS OF USE CONTAIN A MANDATORY ARBITRATION PROVISION
            THAT, AS FURTHER SET FORTH IN SECTION 19 BELOW, REQUIRES THE USE OF
            ARBITRATION ON AN INDIVIDUAL BASIS TO RESOLVE DISPUTES. THIS MEANS
            THAT YOU AND Parkhaven ARE EACH GIVING UP THE RIGHT TO SUE EACH
            OTHER IN COURT OR IN CLASS ACTIONS OF ANY KIND. IN ARBITRATION,
            THERE IS NO JUDGE OR JURY AND THERE IS LESS DISCOVERY AND APPELLATE
            REVIEW THAN IN COURT.
            <br />
            <br />
            Parkhaven Living, LLC, a subsidiary of Columbia Sportwear Company,
            together with its subsidiaries and affiliates (“Parkhaven”),
            provides you access and use of its websites and mobile applications
            (collectively, the “Sites”) and permits you to place orders subject
            to your compliance with these terms and conditions of use (these
            “Site Terms”). BY CREATING AN ACCOUNT, PLACING AN ORDER, OR
            ACCESSING OR USING THE SITES, OR OTHERWISE AGREEING TO THE TERMS,
            YOU AGREE TO BE BOUND BY THESE SITE TERMS AND ALL APPLICABLE LAW. IF
            YOU DO NOT AGREE TO BE BOUND BY THESE SITE TERMS AND APPLICABLE LAW
            EACH TIME YOU USE THE SITES OR IF YOU DO NOT HAVE THE AUTHORITY TO
            AGREE TO OR ACCEPT THESE TERMS, YOU MAY NOT USE THE SITES.
            <br />
            <br />
            These Site Terms apply to your access to, and use of, the Sites.
            These Site Terms do not alter in any way the terms or conditions of
            any other agreement you may have with Parkhaven for products,
            services or otherwise. The Terms of Sale also apply to any orders
            you submit to Parkhaven. If you are using the Sites on behalf of any
            entity, you represent and warrant that you are authorized to accept
            these Site Terms on such entity's behalf, and that such entity
            agrees to indemnify you and Parkhaven for violations of these Site
            Terms.
            <br />
            <br />
            If Parkhaven offers any rewards, contests, sweepstakes, program, or
            other offers or promotions on the Site, you agree to any additional
            posted terms, conditions, rules, or guidelines, which are hereby
            incorporated by reference into these Site Terms.
            <br />
            <br />
            Parkhaven reserves the right to change or modify any of the terms
            and conditions contained in the Site Terms or any policy or
            guideline of the Sites, at any time and in its sole discretion.
            Parkhaven will notify you when the Site Terms have been changed by
            email or by posting the revised Site Terms on the Sites and posting
            a notice about such changes on the Sites. Any changes or
            modification will be effective immediately upon posting of the
            revisions on the Sites and shall apply to all use of the Sites and
            all acts or omissions occurring after the effective date of the
            revised Site Terms. You waive any right you may have to receive
            specific notice of such changes or modifications. Your continued use
            of the Sites following the posting of changes or modifications will
            confirm your acceptance of such changes or modifications. Therefore,
            you should frequently review the Site Terms and applicable policies
            to understand the terms and conditions that apply to your use of the
            Sites. If you do not agree to the amended Site Terms, your license
            to use the Sites will terminate and any further use will be
            unauthorized, so you must stop using the Sites.
            <br />
            <br />
            If you have any question regarding the use of the Sites, please
            refer first to the Help Section or the Frequently Asked Questions.
            All other questions or comments about the Sites or their contents
            should be directed to Parkhaven via the{" "}
            <Link
              onClick={toTop}
              to="/contact"
              style={{ textDecoration: "underline", color: "#03313f" }}
            >
              contact us form
            </Link>
            .
            <br />
            <br />
            <b>1. Privacy Policy</b>
            <br />
            Please refer to our{" "}
            <Link
              onClick={toTop}
              to="/privacy"
              style={{ textDecoration: "underline", color: "#03313f" }}
            >
              Privacy Policy
            </Link>{" "}
            hereby incorporated by reference into these Site Terms, for
            information on how Parkhaven collects, uses and discloses personally
            identifiable information from its users.
            <br />
            <br />
            <b>2. Mobile Services and Contact Information</b>
            <br />
            You may be required to provide a phone number to create an account,
            place an order, or participate in programs or promotions. The Sites
            may include certain features or services that are available via your
            mobile phone or device, such as the ability to upload content to
            your mobile phone or request payment links, order and shipping
            status messages, product information, promotional offers, or other
            information or alerts be sent to your mobile phone or device (the
            “Mobile Services”). By using the Mobile Services, or by providing
            your mobile number as a contact point, you agree that Parkhaven may
            communicate with you by SMS, MMS, text message or other electronic
            means to your mobile device and that certain information about your
            usage of the Mobile Services may be communicated to us. You are not
            required to provide your mobile number, consent to receive marketing
            messages, or use Mobile Services to make a purchase. If you do not
            provide your mobile number to Parkhaven, you may not receive Mobile
            Services. Mobile Services may not be accessible or may have limited
            utility over some carriers. Parkhaven cannot guarantee that all
            carriers will support Mobile Services. You understand that your
            carrier's messaging, data and other rates and fees will apply to
            Mobile Services and other communications. You should check with your
            carrier to find out if Mobile Services are available to you, what
            plans are available, and how much they cost. Text messages may be
            provided using automated technology. Text message frequency varies
            and message and data rates may apply. If you receive a Mobile
            Services message from Parkhaven, you may also reply “HELP” for help
            or “STOP” to cancel. For additional information and assistance,
            please call us at{" "}
            <Link onClick={toTop} to="tel:8006226953">
              (800) 622-6953
            </Link>
            . You consent to receive communications from Parkhaven
            electronically via SMS, MMS, text method, E-mail, or other
            electronic means. You agree that all agreements, notices,
            disclosures, and other communications that Parkhaven provides to you
            electronically satisfy any legal requirements that such
            communications be in writing. All notices by you to Parkhaven must
            be in writing and addressed to: RM A6,UNIT 126, 1/F, 143 WAIYIP ST,
            KWUN TONG <br />
            HONG KONG.
            <br />
            <br />
            <b>3. Copyright and Limited License</b>
            <br />
            Unless otherwise indicated in the Sites, the Sites and all content
            and other materials on the Sites, including, without limitation, the
            Parkhaven logo and all designs, text, graphics, pictures,
            information, data, software, sound files, other files and the
            selection and arrangement thereof (collectively, the "Site
            Materials") are the proprietary property of Parkhaven or its
            licensors or users and are protected by U.S. and international
            copyright laws.
            <br />
            <br />
            You are granted a limited, non-sublicensable license to access and
            use the Sites and electronically copy, (except where prohibited
            without a license) and print to hard copy portions of the Site
            Materials for your informational, non-commercial and personal use
            only. Such license is subject to these Site Terms and does not
            include: (a) any resale or commercial use of the Sites or the Site
            Materials therein; (b) the collection and use of any product
            listings, pictures or descriptions; (c) the distribution, public
            performance or public display of any Site Materials, (d) modifying
            or otherwise making any derivative uses of the Sites and the Site
            Materials, or any portion thereof; (e) use of any data mining,
            robots or similar data gathering or extraction methods; (f)
            downloading (other than the page caching) of any portion of the
            Sites, the Site Materials or any information contained therein,
            except as expressly permitted on the Sites; or (g) any use of the
            Sites or the Site Materials other than for their intended purpose.
            Any use of the Site or the Site Materials other than as specifically
            authorized herein, without the prior written permission of
            Parkhaven, is strictly prohibited and will terminate the license
            granted herein. Such unauthorized use may also violate applicable
            laws including without limitation copyright and trademark laws and
            applicable communications regulations and statutes. Unless
            explicitly stated herein, nothing in these Site Terms shall be
            construed as conferring any license to intellectual property rights,
            whether by estoppel, implication or otherwise. This license is
            revocable at any time.
            <br />
            <br />
            <b>4. Repeat Infringer Policy</b>
            <br />
            In accordance with the Digital Millennium Copyright Act (DMCA) and
            other applicable law, Parkhaven has adopted a policy of terminating,
            in appropriate circumstances and at Parkhaven's sole discretion,
            subscribers or account holders who are deemed to be repeat
            infringers. Parkhaven may also at its sole discretion limit access
            to the Sites and/or terminate the accounts of any users who infringe
            any intellectual property rights of others, whether or not there is
            any repeat infringement.
            <br />
            <br />
            <b>5. Copyright Complaints</b>
            <br />
            If you believe that anything on the Site infringes upon any
            copyright which you own or control, you may file a notification of
            such infringement with our Designated Agent as set forth below.
            <br />
            <br />
            <div style={{ marginLeft: 20 }}>
              Name of Agent Designated to Receive Notification of Claimed
              Infringement: John C. Motley
              <br />
              Full Address of Designated Agent to Which Notification Should be
              Sent: 413 Carrington Ln, Douglasville, GA 30135US
              <br />
              E-Mail Address of Designated Agent:{" "}
              <Link onClick={toTop} to="mailto:enter@parkhaven.cloud">
                enter@parkhaven.cloud
              </Link>
              <br />
            </div>
            <br />
            Please see 17 U.S.C. §512(c)(3) for the requirements of a proper
            notification. Please note that the information provided in your
            notification, including any personal information contained therein,
            may be forwarded to the person who has provided the allegedly
            infringing content, and your sending us such notification
            constitutes your consent to share this information with the alleged
            infringer.
            <br />
            <br />
            You should also note that if you make any material misrepresentation
            in your notification that the material or activity is infringing,
            you will be liable for all damages, including costs and attorneys'
            fees, incurred by us or the alleged infringer as the result of our
            relying upon such misrepresentation in removing or disabling access
            to the material or activity claimed to be infringing.
            <br />
            <br />
            Parkhaven may give notice of a claim of copyright infringement to
            our users by means of a general notice on the Sites, electronic mail
            to a user's email address in our records, or by written
            communication sent by first-class mail to a user's address in our
            records.
            <br />
            <br />
            <b>6. Trademarks</b>
            <br />
            "Parkhaven Living, LLC," the Parkhaven sitting pose logo, and other
            product or service names, logos and slogans of Parkhaven that may
            appear on the Sites, are trademarks or registered trademarks of
            Parkhaven and may not be copied, imitated or used, in whole or in
            part, without the prior written permission of Parkhaven or the
            applicable trademark holder. You may not use any metatags or any
            other "hidden text" utilizing "Parkhaven" or any other name,
            trademark or product or service name of Parkhaven or its
            subsidiaries without our prior written permission. In addition, the
            look and feel of the Sites, including all page headers, custom
            graphics, button icons and scripts, is the service mark, trademark
            and/or trade dress of Parkhaven and may not be copied, imitated or
            used, in whole or in part, without our prior written permission.
            However, nothing herein prohibits you from using Parkhaven’s name,
            trademark or product name in your review of Parkhaven’s products and
            services. All other trademarks, registered trademarks, product names
            and company names or logos mentioned in the Sites are the property
            of their respective owners. Reference to any products, services,
            processes or other information, by trade name, trademark,
            manufacturer, supplier or otherwise does not constitute or imply
            endorsement, sponsorship or recommendation thereof by us.
            <br />
            <br />
            <b>7. Hyperlinks</b>
            <br />
            You are granted a limited, non-exclusive right to create a text
            hyperlink to the Sites for noncommercial purposes, provided such
            link does not portray Parkhaven or any of its products and services
            in a false, misleading, derogatory or otherwise defamatory manner
            and provided further that the linking site does not contain any
            adult or illegal material or any material that is offensive,
            harassing or otherwise objectionable. This limited right may be
            revoked at any time. You may not use a Parkhaven logo or other
            proprietary graphic of Parkhaven to link to the Sites without the
            express written permission of Parkhaven. Further, you may not use,
            frame or utilize framing techniques to enclose any Parkhaven
            trademark, logo or other proprietary information, including the
            images found at the Sites, the content of any text or the
            layout/design of any page or form contained on a page on the Sites
            without Parkhaven's express written consent. Except as noted above,
            you are not conveyed any right or license by implication, estoppel
            or otherwise in or under any patent, trademark, copyright or
            proprietary right of Parkhaven or any third party.
            <br />
            <br />
            Parkhaven makes no claim or representation regarding, and accepts no
            responsibility for, the quality, content, nature or reliability of
            third-party Web sites accessible by hyperlink from the Sites, or Web
            sites linking to the Sites. Such sites are not under the control of
            Parkhaven and Parkhaven is not responsible for the contents of any
            linked site or any link contained in a linked site, or any review,
            changes or updates to such sites. Parkhaven provides these links to
            you only as a convenience, and the inclusion of any link does not
            imply affiliation, endorsement or adoption by Parkhaven of any site
            or any information contained therein. When you leave the Sites, you
            should be aware that our terms and policies no longer govern. You
            should review the applicable terms and policies, including privacy
            and data gathering practices, of any site to which you navigate from
            the Sites.
            <br />
            <br />
            <b>8. Third Party Content</b>
            <br />
            Parkhaven may provide or allow third party content on the Sites and
            may provide or allow links to Web pages and content of third parties
            (collectively the "Third Party Content") as a service to those
            interested in this information. Parkhaven does not monitor or have
            any control over any Third Party Content or third party Web sites.
            Parkhaven does not endorse or adopt any Third Party Content and can
            make no guarantee as to its accuracy or completeness. Parkhaven does
            not represent or warrant the accuracy of any information contained
            therein and undertakes no responsibility to update or review any
            Third Party Content. Users use such Third Party Content contained
            therein at their own risk. Product reviews and comments posted on
            the Sites are strictly the opinion of the user posting such reviews
            or comments, and Parkhaven does not endorse or approve any such
            reviews or comments.
            <br />
            <br />
            AI-Generated Content. Parkhaven may use artificial intelligence
            tools to generate summaries or highlights of product reviews or
            other content on the Sites. These AI-generated summaries are
            provided for your convenience only. Parkhaven does not guarantee the
            accuracy, completeness, or reliability of any AI-generated content.
            Any reliance on such content is at your own risk, and Parkhaven is
            not liable for any errors or omissions in AI-generated summaries.
            You are encouraged to review the full product reviews and other
            original content to form your own opinion.
            <br />
            <br />
            <b>
              9. Advertisements and Promotions; Third-Party Products and
              Services
            </b>
            <br />
            Parkhaven may run or allow advertisements and promotions from third
            parties on the Sites or may otherwise provide or allow information
            about or links to third-party products or services on the Sites.
            Your business dealings or correspondence with, or participation in
            promotions of, such third parties, and any terms, conditions,
            warranties or representations associated with such dealings or
            promotions, are solely between you and such third party. Parkhaven
            is not responsible or liable for any loss or damage of any sort
            incurred as the result of any such dealings or promotions or as the
            result of the presence of such non-Parkhaven advertisers or third
            party information on the Sites.
            <br />
            <br />
            <b>10. User Content and Interactive Services or Areas</b>
            <br />
            The Sites may include discussion forums, blogs, product reviews, or
            other interactive areas or services ("Interactive Areas") in which
            you or other users create, post or store any content, messages,
            reviews, ratings, materials, data, information, text, music, sound,
            photos, video, graphics, code or other items or materials on the
            Sites ("User Content"). You are solely responsible for your use of
            such Interactive Areas and use them at your own risk. You agree not
            to post, upload to, transmit, distribute, store, create or otherwise
            publish through the Sites any of the following:
            <br />
            <br />
            <ol style={{ listStyleType: "padding: 0 0 0 0em", margin: 0 }}>
              <li style={{ padding: ".5em 0" }}>
                User Content that is unlawful, libelous, obscene, pornographic,
                indecent, lewd, suggestive, harassing, threatening, invasive of
                privacy or publicity rights, or fraudulent;
              </li>
              <li style={{ padding: ".5em 0" }}>
                User Content that you know or have reason to know is inaccurate,
                untruthful or misleading;
              </li>
              <li style={{ padding: ".5em 0" }}>
                User Content that would constitute, encourage or provide
                instructions for a criminal offense, violate the rights of any
                party, or that would otherwise create liability or violate any
                local, state, national or international law;
              </li>
              <li style={{ padding: ".5em 0" }}>
                User Content that may infringe any patent, trademark, trade
                secret, copyright or other intellectual or proprietary right of
                any party. By posting any User Content, you represent and
                warrant that you have the lawful right to distribute and
                reproduce such User Content;
              </li>
              <li style={{ padding: ".5em 0" }}>
                User Content that impersonates any person or entity or otherwise
                misrepresents your affiliation with a person or entity;
              </li>
              <li style={{ padding: ".5em 0" }}>
                Unsolicited promotions, political campaigning, advertising or
                solicitations;
              </li>
              <li style={{ padding: ".5em 0" }}>
                Private information of any third party, including, without
                limitation, addresses, phone numbers, email addresses, Social
                Security numbers and credit card numbers; and
              </li>
              <li style={{ padding: ".5em 0" }}>
                Viruses, corrupted data or other harmful, disruptive or
                destructive files.
              </li>
            </ol>
            <br />
            Parkhaven takes no responsibility and assumes no liability for any
            User Content posted, stored or uploaded by you or any third party,
            or for any loss or damage thereto, nor is Parkhaven liable for any
            mistakes, defamation, slander, libel, omissions, falsehoods,
            obscenity, pornography or profanity you may encounter.
            <br />
            <br />
            Your use of Interactive Areas is at your own risk. As a provider of
            interactive services, Parkhaven is not liable for any statements,
            representations or User Content provided by its users in any public
            forum, personal home page or other Interactive Area. Although
            Parkhaven has no obligation to screen, edit or monitor any of the
            User Content posted in any Interactive Area, Parkhaven reserves the
            right, and has absolute discretion, to remove, screen or edit any
            User Content posted or stored on the Sites and/or to limit your use
            of the Sites at any time and for any reason without notice.
            Parkhaven will not remove or edit User Content on the basis that it
            is a negative review of Parkhaven’s products or services. You are
            solely responsible for creating backup copies of and replacing any
            User Content you post or store on the Sites at your sole cost and
            expense. Any use of the Interactive Areas or other portions of the
            Sites in violation of the foregoing violates these Site Terms and
            may result in, among other things, termination or suspension of your
            rights to use the Interactive Areas and/or the Sites. In order to
            cooperate with legitimate governmental requests, subpoenas or court
            orders, to protect Parkhaven's systems and customers, or to ensure
            the integrity and operation of Parkhaven's business and systems,
            Parkhaven may access and disclose any information it considers
            necessary or appropriate, including, without limitation, user
            profile information (i.e. name, e-mail address, etc.), IP addressing
            and traffic information, usage history, and posted User Content.
            Parkhaven's right to disclose any such information shall govern over
            any terms of Parkhaven's Privacy Policy.
          </div>
          <div
            id="te6_378002b2_62f6_45a1_b536_876df7c3c925"
            className="font-size-12 font-size-lg-16 text-left line-height-default font-sans-serif text-black"
            role="group"
          >
            <br />
            <b>11. Rights in User Content and Submissions</b>
            <br />
            Except as otherwise expressly stated by Parkhaven, Parkhaven does
            not claim ownership of any User Content or other materials you post
            or upload on the Sites or otherwise provide or submit to Parkhaven.
            However, unless we indicate otherwise, you grant Parkhaven and its
            affiliates a nonexclusive, royalty-free, perpetual, irrevocable and
            fully sublicensable right to use, reproduce, modify, adapt, publish,
            translate, create derivative works from, distribute, perform and
            display such User Content throughout the world in any media. Such
            license shall be limited to use on or in connection with the Sites
            unless otherwise indicated on the Sites. You grant Parkhaven and its
            sublicensees the right to use the name that you submit in connection
            with such User Content, if they choose. You represent and warrant
            that (a) you own and control all of the rights to the User Content
            that you post or you otherwise have the right to post such User
            Content to the Sites; (b) the User Content is accurate and not
            misleading; and (c) use and posting of the User Content you supply
            does not violate these Site Terms and will not violate any rights of
            or cause injury to any person or entity.
            <br />
            <br />
            Notwithstanding the foregoing, you acknowledge and agree that any
            suggestions, ideas, comments or other information or materials you
            provide regarding the Sites, Parkhaven or Parkhaven's products or
            services, whether by email, posting to the Sites or otherwise, are
            non-confidential and shall become the sole property of Parkhaven.
            Parkhaven shall own exclusive rights, including all intellectual
            property rights, and shall be entitled to the unrestricted use and
            dissemination of these materials for any purpose, commercial or
            otherwise, without acknowledgment or compensation to you.
            <br />
            <br />
            <b>12. User Conduct</b>
            <br />
            When creating or updating an account or participating in programs or
            promotions, you may be required to provide certain personal
            information including, but not limited to, your name, contact, and
            payment information. This information will be held and used in
            accordance with Parkhaven’s Privacy Policy and any other related
            notices provided in connection with our information collection or
            use. You agree to provide complete, truthful, and accurate
            information, and to update such information promptly if it changes.
            You also agree not to:
            <br />
            <br />
            <ul>
              • Use the Sites or Interactive Areas in any unlawful manner or in
              any manner that could damage, disable, overburden or impair the
              Sites;
            </ul>
            <ul>
              • Harvest or collect email addresses or other contact information
              of other users from the Sites or Interactive Areas by electronic
              or other means for the purposes of sending unsolicited emails or
              other unsolicited communications;
            </ul>
            <ul>
              • Use any robot, spider, crawler, scraper or other automated means
              or interface not provided by us to access the Sites and/or
              Interactive Areas or to extract data;
            </ul>
            <ul>
              • Use automated scripts to collect information from or otherwise
              interact with the Sites or Interactive Areas;
            </ul>
            <ul>
              • Register for more than one user account, register for a user
              account on behalf of an individual other than yourself, or
              register for a user account on behalf of any group or entity;
            </ul>
            <ul>
              • Provide incomplete, false, or inaccurate biographical or other
              information for purposes of registering as a user, creating an
              account, placing an order or participating in any program or
              promotion;
            </ul>
            <ul>
              • Impersonate any person or entity or otherwise misrepresent your
              age or your affiliation with a person or entity;
            </ul>
            <ul>• Use the Site or your account for a commercial purpose;</ul>
            <ul>• Violate any local, state, national or international law;</ul>
            <ul>
              • Solicit personal information from anyone under 18 or solicit
              passwords or personally identifying information for commercial or
              unlawful purposes;
            </ul>
            <ul>
              • Use or attempt to use another's account without authorization
              from Parkhaven;
            </ul>
            <ul>
              • Attempt to circumvent any content filtering techniques we may
              employ;
            </ul>
            <ul>
              • Attempt to access any service or area of the Sites (including,
              without limitation, any Interactive Areas) that you are not
              authorized to access; or
            </ul>
            <br />
            Engage in any harassing, intimidating, predatory or stalking
            conduct. Parkhaven is not responsible or liable for the conduct of,
            or your interactions with, users of the Sites (whether online or
            offline), nor is Parkhaven responsible or liable for any loss,
            damage, injury, or harm associated therewith. However, the foregoing
            shall not apply to the extent that any loss or damage is the result
            of Parkhaven’s own gross negligence, fraud, willful injury or
            willful violation of law.
            <br />
            <br />
            Although Parkhaven has no obligation to monitor any user conduct on
            the Sites or in any Interactive Area, Parkhaven reserves the right,
            and has absolute discretion, to monitor any user conduct on the
            Sites at any time and for any reason without notice. Parkhaven does
            not approve or endorse any user-posted meetings or events referenced
            on the Sites, and Parkhaven recommends exercising caution before
            contacting or meeting anyone (online or offline) that is unfamiliar.
            You use of the Sites is at your own risk. Any use of the Sites in
            violation of the user conduct rules set forth above violates these
            Site Terms and may result in, among other things, termination or
            suspension of your rights to use the Interactive Areas and/or the
            Sites.
            <br />
            <br />
            <b>13. Registration Data; Account Security</b>
            <br />
            In consideration of your use of the Sites, you agree to (a) provide
            accurate, current and complete information about you as may be
            prompted by any registration forms on the Sites ("Registration
            Data"); (b) maintain the security of your password and
            identification and not share such information with any third party;
            (c) maintain and promptly update the Registration Data, and any
            other information you provide to Parkhaven, to keep it accurate,
            current and complete; and (d) accept all risks of unauthorized
            access to the Registration Data and any other information you
            provide to Parkhaven. You accept responsibility for all activities
            that occur on your account or with your password. You will
            immediately notify Parkhaven and change your login information if
            the confidentiality of your account or password is compromised in
            any way. Parkhaven reserves the right to take any and all action it
            deems necessary or advisable to maintain the security of the Sites
            and your account, including but not limited to terminating your
            account, changing your password, or requesting information to
            authorize transactions on your account. Parkhaven may communicate
            with you via unencrypted email. Such communication is not secure and
            may be viewed by others. Parkhaven is not liable to you for any
            liability or damages resulting from or arising out of any compromise
            of your account or password, or any unauthorized access to your
            account or communications between us or use of your password.
            <br />
            <br />
            <b>14. Financial Material Disclosure</b>
            <br />
            Forward-Looking Statements. This Site, and any documents issued by
            Parkhaven or Columbia Sportswear Company (“Columbia”) and available
            through the Sites, may contain statements which constitute
            forward-looking statements within the meaning of the U.S. Private
            Securities Litigation Reform Act of 1995. Those statements can be
            identified by the use of words such as "believe," "expect," "plan,"
            "may," "will," "should," "anticipate" or similar statements or the
            negative of these words. Forward-looking statements include
            statements made as to future operations, costs, capital
            expenditures, cash flow, improvements in infrastructure,
            distribution and replenishment systems and operating efficiencies,
            sales and earnings estimates or trends and expansion plans and
            projections. These forward-looking statements are based on our
            current expectations. Known and unknown internal and external risks
            and uncertainties may cause the actual results to be materially
            different from those expressed in or implied by the forward-looking
            statements. The information contained in the most recent Columbia
            Annual Reports to stockholders, including information contained
            under the section captioned "Management’s Discussion and Analysis,"
            as well as other information included under the caption "Risk
            Factors" and/or in other Columbia filings with the Securities and
            Exchange Commission, identifies important factors that could cause
            actual results to differ from those contemplated by forward-looking
            statements. Columbia and Parkhaven undertake no obligation to update
            forward-looking statements to reflect events or circumstances that
            occur after the date the statements were made.
            <br />
            <br />
            Press Releases. The information contained within press releases
            issued by Parkhaven should not be deemed accurate or current except
            as of the date the release was posted. Parkhaven has no intention of
            updating, and specifically disclaims any duty to update, the
            information in the press releases. To the extent any information
            therein is forward-looking, it is intended to fit within the safe
            harbor for forward-looking statements, and is subject to material
            risk.
            <br />
            <br />
            Third-Party Financial Information. Parkhaven may provide links to
            third-party Web sites or services that contain financial or
            investment information about Columbia . Access to such Web sites and
            the information contained therein is provided as service to those
            interested in the information. Parkhaven neither regularly monitors
            nor has control over the content of third parties' statements or Web
            sites. Accordingly, Parkhaven does not endorse or adopt these Web
            sites or any information contained therein, including, without
            limitation, analyst's reports and stock quotes. Parkhaven makes no
            representations or warranties whatsoever regarding the accuracy or
            completeness of the content, information, or opinions of third-party
            Web sites or other third-party information that is identified on the
            Site. Users visit these Web sites and use the information contained
            therein at their own risk.
            <br />
            <br />
            <b>15. Indemnification</b>
            <br />
            To the fullest extent permitted by law, you agree to defend,
            indemnify and hold harmless Parkhaven, its independent contractors,
            service providers and consultants, and their respective directors,
            employees and agents, from and against any claims, damages, costs,
            liabilities and expenses (including, but not limited to, reasonable
            attorneys' fees) arising out of or related to any User Content you
            post, store or otherwise transmit on or through the Sites or your
            use of the Interactive Areas, including without limitation any
            actual or threatened suit, demand or claim made against Parkhaven
            and/or its independent contractors, service providers, employees,
            directors or consultants, arising out of or relating to the User
            Content, your conduct, your violation of these Site Terms or your
            violation of law, regulation, or rights of any third party.
            <br />
            <br />
            <b>16. Disclaimer</b>
            <br />
            EXCEPT AS EXPRESSLY PROVIDED TO THE CONTRARY IN A WRITING BY
            Parkhaven, TO THE FULLEST EXTENT PERMITTED BY LAW, THE SITES, THE
            SITE MATERIALS CONTAINED THEREIN (INCLUDING ALL USER CONTENT) AND
            THE SERVICES PROVIDED ON OR IN CONNECTION THEREWITH (THE "SERVICES")
            ARE PROVIDED ON AN "AS IS" AND “AS AVAILABLE” BASIS WITHOUT
            WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. Parkhaven
            DISCLAIMS ALL OTHER WARRANTIES, EXPRESS OR IMPLIED, INCLUDING,
            WITHOUT LIMITATION, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS
            FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT AS TO THE
            INFORMATION, USER CONTENT AND SITE MATERIALS IN THE SITES. Parkhaven
            DOES NOT REPRESENT OR WARRANT THAT THE SITES, THE SITE MATERIALS OR
            THE SERVICES ARE ACCURATE, COMPLETE, RELIABLE, CURRENT OR
            ERROR-FREE. Parkhaven IS NOT RESPONSIBLE FOR THE CONDUCT, WHETHER
            ONLINE OR OFFLINE, OF ANY USER OF THE SITES OR THE SERVICE, AND YOU
            ARE SOLELY RESPONSIBLE FOR YOUR INTERACTIONS WITH OTHER USERS.
            PRODUCT REVIEWS AND COMMENTS ARE STRICTLY THE OPINION OF THE USER
            POSTING SUCH REVIEWS OR COMMENTS, AND Parkhaven DOES NOT ENDORSE OR
            APPROVE ANY SUCH REVIEWS OR COMMENTS. SOME JURISDICTIONS TO NOT
            ALLOW THE DISCLAIMER OF IMPLIED WARRANTIES, SO THIS SECTION MAY NOT
            APPLY TO YOU IN WHOLE OR IN PART.
            <br />
            <br />
            Parkhaven IS NOT RESPONSIBLE FOR TYPOGRAPHICAL ERRORS OR OMISSIONS
            RELATING TO PRICING, TEXT OR PHOTOGRAPHY. WHILE Parkhaven ATTEMPTS
            TO MAKE YOUR ACCESS AND USE OF THE SITES AND THE SERVICES SAFE,
            Parkhaven CANNOT AND DOES NOT REPRESENT OR WARRANT THAT THE SITES OR
            ITS SERVER(S) ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS;
            THEREFORE, YOU SHOULD USE INDUSTRY-RECOGNIZED SOFTWARE TO DETECT AND
            DISINFECT VIRUSES FROM ANY DOWNLOAD.
            <br />
            <br />
            Parkhaven reserves the right to change any and all content contained
            in the Sites and any Services offered through the Sites at any time
            without notice. Reference to any products, services, processes or
            other information, by trade name, trademark, manufacturer, supplier
            or otherwise does not constitute or imply endorsement, sponsorship
            or recommendation thereof, or any affiliation therewith, by
            Parkhaven.
            <br />
            <br />
            <b>17. Limitation of Liability</b>
            <br />
            TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT SHALL Parkhaven,
            ITS DIRECTORS, MEMBERS, EMPLOYEES OR AGENTS BE LIABLE FOR ANY
            DIRECT, SPECIAL, INDIRECT OR CONSEQUENTIAL DAMAGES, OR ANY OTHER
            DAMAGES OF ANY KIND, INCLUDING BUT NOT LIMITED TO LOSS OF USE, LOSS
            OF PROFITS OR LOSS OF DATA, WHETHER IN AN ACTION IN CONTRACT, TORT
            (INCLUDING BUT NOT LIMITED TO NEGLIGENCE) OR OTHERWISE, ARISING OUT
            OF OR IN ANY WAY CONNECTED WITH THE USE OF OR INABILITY TO USE THE
            SITES, THE SERVICES, THE USER CONTENT OR THE SITE MATERIALS
            CONTAINED IN OR ACCESSED THROUGH THE SITES, INCLUDING WITHOUT
            LIMITATION ANY DAMAGES CAUSED BY OR RESULTING FROM YOUR RELIANCE ON
            ANY INFORMATION OBTAINED FROM Parkhaven, OR THAT RESULT FROM
            MISTAKES, OMISSIONS, INTERRUPTIONS, DELETION OF FILES OR EMAIL,
            ERRORS, DEFECTS, VIRUSES, DELAYS IN OPERATION OR TRANSMISSION OR ANY
            FAILURE OF PERFORMANCE, WHETHER OR NOT RESULTING FROM ACTS OF GOD,
            COMMUNICATIONS FAILURE, THEFT, DESTRUCTION OR UNAUTHORIZED ACCESS TO
            Parkhaven's RECORDS, PROGRAMS OR SERVICES. IN NO EVENT SHALL THE
            AGGREGATE LIABILITY OF Parkhaven, WHETHER IN CONTRACT, WARRANTY,
            TORT (INCLUDING NEGLIGENCE, WHETHER ACTIVE, PASSIVE OR IMPUTED),
            PRODUCT LIABILITY, STRICT LIABILITY OR OTHER THEORY, ARISING OUT OF
            OR RELATING TO YOUR USE OF OR INABILITY TO USE THE SITES EXCEED ANY
            COMPENSATION YOU PAY, IF ANY, TO Parkhaven FOR ACCESS TO OR USE OF
            THE SITES.
            <br />
            <br />
            <b>18. Governing Law and Venue</b>
            <br />
            The Sites are intended for use by adults in the U.S. You agree to
            monitor your account and restrict use by minors. The Sites are
            operated by U.S. and are governed by the laws of the State of
            Oregon, which may be different than the laws of your jurisdiction.
            If you access the sites from outside the U.S., you do so at your own
            risk and are responsible for compliance with the laws of your
            jurisdiction in addition to the laws of the State of Oregon. You may
            not use the Sites if you are the subject of U.S. sanctions or of
            sanctions consistent with U.S. law imposed by the government of the
            country where you are accessing the Sites. You are responsible for
            compliance with all U.S. and other export restrictions that may
            apply to your use of the Sites or product purchases. <br />
            Any action not required to be arbitrated in accordance with Section
            19 of these Site Terms shall be filed only in the state and federal
            courts located in Multnomah County, Oregon and you hereby
            irrevocably and unconditionally consent and submit to the exclusive
            jurisdiction of such courts over any such suit, action or
            proceeding. Any dispute arising from or related to these Site Terms,
            your use of the Sites, Parkhaven products, Parkhaven Services, or
            any aspect of the relationship between you and Parkhaven as relates
            to these Site Terms shall be governed by and construed in accordance
            with the laws of the State of Oregon, applicable to agreements made
            and to be entirely performed within the State of Oregon, without
            resort to its conflict of law provisions and regardless of where you
            access the Sites.
            <br />
            <br />
            <b>19. Dispute Resolution</b>
            <br />
            PLEASE READ THIS SECTION CAREFULLY BECAUSE IT REQUIRES YOU AND
            Parkhaven TO ARBITRATE CERTAIN DISPUTES AND CLAIMS AND LIMITS THE
            MANNER IN WHICH WE CAN SEEK RELIEF FROM EACH OTHER. ARBITRATION
            PRECLUDES YOU AND Parkhaven FROM SUING IN COURT OR HAVING A JURY
            TRIAL. YOU AND Parkhaven AGREE THAT ARBITRATION WILL BE SOLELY ON AN
            INDIVIDUAL BASIS AND NOT AS A CLASS ARBITRATION, CLASS ACTION, OR
            ANY OTHER KIND OF REPRESENTATIVE PROCEEDING. Parkhaven AND YOU ARE
            EACH WAIVING THE RIGHT TO TRIAL BY A JURY.
            <br />
            <br />
            FOLLOW THE INSTRUCTIONS BELOW IF YOU WISH TO OPT OUT OF THE
            REQUIREMENT OF ARBITRATION ON AN INDIVIDUAL BASIS. NO CLASS OR
            REPRESENTATIVE ACTIONS OR ARBITRATIONS ARE ALLOWED UNDER THIS
            ARBITRATION AGREEMENT.
            <br />
            <br />
            <ol type="a">
              <li>
                <b>Pre-Arbitration Dispute Notification.</b> For any dispute or
                claim that you have against Parkhaven, that Parkhaven has
                against you or that you have, or Parkhaven has, in each case
                arising from, relating to, or stemming from these Site Terms,
                Parkhaven products, or Parkhaven Services, or any aspect of the
                relationship between you and Parkhaven as relates to these Site
                Terms, Parkhaven products, or Parkhaven Services, including any
                privacy or data security claims, (collectively, “Claims”, and
                each a “Claim”), you and Parkhaven agree to attempt to first
                resolve the Claim informally via the following process.
              </li>
              <br />
              <ol type={1}>
                <li>
                  If you assert a Claim against Parkhaven, you will first
                  contact Parkhaven by sending a written notice of your Claim
                  (“Claimant Notice”) to Parkhaven by certified mail addressed
                  to Parkhaven at Parkhaven Living, LLC, Attn: General Counsel,
                  14375 NW Science Park Drive, Portland, Oregon 97229. The
                  Claimant Notice must (i) include your name, residence address,
                  email address, and telephone number; (ii) describe the nature
                  and basis of the Claim; and (iii) set forth the specific
                  relief sought.
                </li>
                <li>
                  If Parkhaven asserts a Claim against you, Parkhaven will first
                  contact you by sending a written notice of Parkhaven’s Claim
                  (“Parkhaven Notice”, and each of a Claimant Notice and
                  Parkhaven Notice, a “Notice”) to you via certified mail to the
                  mailing address associated with your account or, if such
                  information is not available, to the primary email address
                  associated with your account, or to other contact information.
                  The Parkhaven Notice must (i) include the name of a Parkhaven
                  contact and the contact’s email address and telephone number;
                  (ii) describe the nature and basis of the Claim; and (iii) set
                  forth the specific relief sought.
                </li>
                <li>
                  You and Parkhaven agree to make attempts to resolve the
                  Claim(s) prior to commencing an arbitration. If requested by
                  the party that receives the Claimant Notice, the other party
                  must participate in a telephone settlement conference to
                  discuss the Claim(s). If a party is represented by counsel,
                  counsel may also participate, but each party must attend. You
                  and Parkhaven also agree that the party that receives the
                  Claimant Notice is entitled to make an offer of judgment
                  pursuant to Rule 68 of the Federal Rules of Civil Procedure,
                  which offer can be shared with any arbitrator later appointed
                  to the matter.
                </li>
                <li>
                  If you and Parkhaven cannot reach an agreement to resolve the
                  Claim within thirty (30) days after you or Parkhaven receives
                  a Claimant Notice, then either party may submit the Claim to
                  binding arbitration as set forth below. The statute of
                  limitations and any filing fee deadlines shall be tolled for
                  thirty (30) days from the date that either you or Parkhaven
                  first send the applicable Notice so that the parties can
                  engage in this informal dispute-resolution process.
                </li>
              </ol>
              <br />
              <li>
                <b>Arbitration Procedure.</b>
                <ol type={1}>
                  <li>
                    If the parties are not able to informally resolve their
                    dispute in the 30-day timeframe described above, then except
                    for individual disputes that qualify for small claims court
                    and any disputes exclusively related to the intellectual
                    property or intellectual property rights of you or Parkhaven
                    (including any disputes in which you or Parkhaven seek
                    injunctive or other equitable relief for the alleged
                    unlawful use of your or Parkhaven’s intellectual property or
                    other infringement of your or Parkhaven’s intellectual
                    property rights (“IP Claims”)), all Claims, whether based in
                    contract, tort, statute, fraud, misrepresentation, or any
                    other legal theory, including Claims that are not related to
                    intellectual property or intellectual property rights but
                    are jointly filed with IP Claims, that are not resolved in
                    accordance with Section 19(a) will be resolved by a neutral
                    arbitrator through final and binding arbitration instead of
                    in a court by a judge or jury. Such Claims include, without
                    limitation, disputes arising out of or relating to
                    interpretation or application of this arbitration provision,
                    including the enforceability, revocability, or validity of
                    the arbitration provision or any portion of the arbitration
                    provision. The arbitrator will have the authority to grant
                    any remedy or relief that would otherwise be available in
                    court.
                  </li>
                  <li>
                    These Site Terms affect interstate commerce, and the
                    enforceability of this Section 19 will be substantively and
                    procedurally governed by the Federal Arbitration Act, 9
                    U.S.C. § 1, et seq., to the extent permitted by law.
                  </li>
                  <li>
                    All Claims must be submitted to the American Arbitration
                    Association (“AAA”) and will be resolved through binding
                    arbitration before one arbitrator. If you are a consumer,
                    the then-current version of the AAA’s Consumer Arbitration
                    Rules will apply, which are available on the AAA’s website
                    (adr.org), as amended by these Site Terms as follows:
                  </li>
                  <ol type="a">
                    <li>
                      YOU AND Parkhaven AGREE THAT ANY ARBITRATION UNDER THESE
                      SITE TERMS WILL TAKE PLACE ON AN INDIVIDUAL BASIS; CLASS
                      ARBITRATIONS AND CLASS ACTIONS ARE NOT PERMITTED, AND YOU
                      AND Parkhaven ARE AGREEING TO GIVE UP THE ABILITY TO
                      PARTICIPATE IN A CLASS ACTION.
                    </li>
                    <li>
                      For any arbitration you initiate, you will pay the
                      consumer filing fee, and Parkhaven will pay the remaining
                      AAA fees and costs. For any arbitration initiated by
                      Parkhaven, Parkhaven will pay all AAA fees and costs.
                    </li>
                    <li>
                      For all arbitrations where the claims asserted are $25,000
                      or less, the arbitration shall be resolved according to
                      the AAA’s Procedures for the Resolution of Disputes
                      through Document Submission, and for all other
                      arbitrations the following procedure will apply: (i) the
                      arbitrator will conduct hearings, if any, by
                      teleconference or videoconference rather than by personal
                      appearances, unless the arbitrator determines upon request
                      by you or by us that an in-person hearing is appropriate;
                      (ii) any in-person appearances will be held at a location
                      which is reasonably convenient to both parties with due
                      consideration of their ability to travel and other
                      pertinent circumstances; and (iii) if the parties are
                      unable to agree on a location, such determination should
                      be made by the AAA or by the arbitrator.
                    </li>
                    <li>
                      If you or Parkhaven submits a dispute to arbitration and
                      the arbitrator orders any exchange of information, you and
                      Parkhaven agree to cooperate to seek from the arbitrator
                      protection for any confidential, proprietary, trade
                      secret, or otherwise sensitive information, documents,
                      testimony, and/or other materials that might be exchanged
                      or the subject of discovery in the arbitration. You and
                      Parkhaven agree to seek such protection before any such
                      information, documents, testimony, and/or materials are
                      exchanged or otherwise become the subject of discovery in
                      the arbitration.
                    </li>
                    <li>
                      The arbitrator’s decision will follow these Site Terms and
                      will be final and binding. The arbitrator will have
                      authority to award temporary, interim, or permanent
                      injunctive relief or relief providing for specific
                      performance of these Site Terms but only to the extent
                      necessary to provide relief warranted by the individual
                      claim before the arbitrator. The award rendered by the
                      arbitrator may be confirmed and enforced in any court
                      having jurisdiction thereof. Notwithstanding any of the
                      foregoing, nothing in these Site Terms will preclude you
                      from bringing issues to the attention of federal, state,
                      or local agencies and, if the law allows, they can seek
                      relief against us for you.
                    </li>
                  </ol>
                  <li>
                    If twenty-five (25) or more similar claims are asserted
                    against Parkhaven or against you by the same or coordinated
                    counsel or are otherwise coordinated (a “Mass Filing”), and
                    the Claims Notice process described in Part 1 above does not
                    resolve the matters so that twenty-five (25) or more
                    coordinated claims exist, then the AAA Mass Arbitration
                    Supplementary Rules shall apply to the extent they are not
                    inconsistent with this paragraph. If a Claim is a part of a
                    Mass Filing, you and Parkhaven agree that counsel for
                    claimants and counsel for Parkhaven shall each select five
                    (5) cases (per side) to proceed first in individual
                    arbitration proceedings. The remaining cases shall be deemed
                    filed for purposes of the statute of limitations but not for
                    the purpose of assessing AAA fees. No AAA fees shall be
                    assessed in connection with those cases until they are
                    selected to proceed to individual arbitration proceedings as
                    part of a bellwether process. If the parties are unable to
                    resolve the remaining cases after the conclusion of the
                    initial ten (10) proceedings, each side shall select another
                    ten (10) cases (per side) to proceed to individual
                    arbitration proceedings as part of a second bellwether
                    process. A single arbitrator shall preside over each case.
                    Only one case may be assigned to each arbitrator as part of
                    a bellwether process unless the parties agree otherwise.
                    This bellwether process shall continue with twenty (20)
                    cases per additional phase, consistent with the parameters
                    identified above, until all the claims included in these
                    coordinated filings, including your case, are adjudicated or
                    otherwise resolved. The statute of limitations and any
                    filing fee deadlines shall be tolled for claims subject to
                    this bellwether process from the time the first cases are
                    selected for a bellwether process until the time your or
                    Parkhaven’s case is selected for a bellwether process,
                    withdrawn, or otherwise resolved. A court shall have
                    authority to enforce this paragraph and, if necessary, to
                    enjoin the mass filing or prosecution of arbitration demands
                    against Parkhaven or you.
                  </li>
                </ol>
                <br />
              </li>
              <li>
                <b>One Year to Assert Claims.</b> To the extent permitted by
                law, any Claim by you or Parkhaven relating in any way to these
                Site Terms, Parkhaven products, or Parkhaven Services, or any
                aspect of the relationship between you and Parkhaven as relates
                to these Site Terms, Parkhaven products, or Parkhaven Services,
                must be filed within one year after such Claim arises;
                otherwise, the Claim is permanently barred, which means that you
                and Parkhaven will not have the right to assert the Claim.
              </li>
              <br />
              <li>
                <b>Right to Opt Out.</b> You have the right to opt out of
                binding arbitration within 30 days of the date you first
                accepted these Site Terms by providing us with notice of your
                decision to opt-out by certified mail addressed to Parkhaven at
                Parkhaven Living, LLC, Attn: General Counsel, 14375 NW Science
                Park Drive, Portland, Oregon 97229. In order to be effective,
                the opt-out notice must include your full name, mailing address,
                and email address. The notice must also clearly indicate your
                intent to opt out of binding arbitration. By opting out of
                binding arbitration, you are agreeing to resolve disputes in
                accordance with Section 18.
              </li>
              <br />
              <li>
                <b>Severability.</b> If any portion of this Section 19 is found
                to be unenforceable or unlawful for any reason, including but
                not limited to because it is found to be unconscionable, (i) the
                unenforceable or unlawful provision will be severed from these
                Site Terms; (ii) severance of the unenforceable or unlawful
                provision will have no impact whatsoever on the remainder of
                this Section 19 or the parties’ ability to compel arbitration of
                any remaining claims on an individual basis pursuant to this
                Section 19; and (iii) to the extent that any claims must
                therefore proceed on a class, collective, consolidated, or
                representative basis, such claims must be litigated in a civil
                court of competent jurisdiction and not in arbitration. The
                litigation of those claims will be stayed pending the outcome of
                any individual claims in arbitration. Further, if any part of
                this Section 19 is found to prohibit an individual claim seeking
                public injunctive relief, that provision will have no effect to
                the extent such relief is allowed to be sought out of
                arbitration, and the remainder of this Section 19 will be
                enforceable.
              </li>
            </ol>
          </div>
          <div
            id="te7_378002b2_62f6_45a1_b536_876df7c3c925"
            className="font-size-12 font-size-lg-16 text-left line-height-default font-sans-serif text-black"
            role="group"
          >
            <br />
            <b>20. Termination</b>
            <br />
            Notwithstanding any of these Site Terms, Parkhaven reserves the
            right, without notice and in its sole discretion, to terminate your
            license to use the Sites, and to block or prevent future your access
            to and use of the Sites.
            <br />
            <br />
            <b>21. Causes Outside of Our Control</b>
            <br />
            A “Cause Outside of Our Control” is any act or event beyond
            Parkhaven’s reasonable control, including but not limited to act of
            God, fire, flood, explosion, war, threat or preparation for war,
            military activity, riot, civil disturbance or strike, lockout or
            other work stoppage, terrorist threat or attack, inclement weather,
            flood, earthquake, epidemic, pandemic, other natural disaster,
            supply chain failures, or failure of public or private
            telecommunications networks. If a Cause Outside of Our Control
            affects our performance of obligations under these Site Terms,
            Parkhaven will notify you as soon as reasonably possible and
            Parkhaven’s obligations to you will be suspended and the time for
            performance of our obligations will be extended for the duration of
            the Cause Outside of Our Control.
            <br />
            <br />
            <b>22. Assignment</b>
            <br />
            Parkhaven may transfer our rights and obligations to another entity,
            but this will not affect your rights or our obligations under these
            Site Terms. You may only transfer your rights or obligations under
            these Site Terms to another person if Parkhaven agrees in writing.
            <br />
            <br />
            <b>23. No Waiver and Severability</b>
            <br />
            The remedies set forth in these Site Terms are cumulative and not
            exclusive, unless expressly stated otherwise. Failure or delay by
            Parkhaven to enforce any provision of these Site Terms will not be
            deemed a waiver of future enforcement of that or any other
            provision. If any provision of these Site Terms shall be deemed
            unlawful, void or for any reason unenforceable, then that provision
            shall be deemed severable from these Site Terms and shall not affect
            the validity and enforceability of any remaining provisions.
            <br />
            <br />
            <b>24. Questions &amp; Contact Information</b>
            <br />
            Questions or comments about the Sites or these Site Terms may be
            directed to Parkhaven via the{" "}
            <Link
              onClick={toTop}
              to="/contact"
              style={{ textDecoration: "underline", color: "#03313f" }}
            >
              contact us form
            </Link>{" "}
            or by calling us at{" "}
            <Link onClick={toTop} to="tel:8669156457">
              (866) 915-6457
            </Link>
            .
            <br />
            <br />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Terms;
